<template>
  <div class="new-group-box">
    <div class="new-group">
      <div class="header row">
        <span>新建分组</span>
        <i @click="cancel" class="cancel-group-next"></i>
      </div>
      <div class="content">
        <input type="text" placeholder="分组名称" v-model="searchText">
      </div>
      <div class="footer">
         <div class="footer-btn">
            <el-button class="cancel-btn" @click="cancel">取消</el-button>
            <el-button class="confirm-btn" @click="confirmGroup">新建</el-button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      searchText: '',
      username: ''
    };
  },
  mounted() {
    this.username = authService.getLoggedUserName();
  },
  methods: {
    cancel() {
      // 关闭弹框
      this.$emit('closeAddGroup', []);
    },
    confirmGroup() {
      // 新增分组接口 searchText,关闭弹框
      QuestionQuery.addFocusGroups({ user: this.username, group_name: this.searchText }).then(() => {
        this.$emit('closeAddGroup', this.searchText);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.new-group-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}
.new-group {
  width: 360px;
  height: 228px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
  border: 1px solid rgba(247, 247, 250, 1);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .header {
    width: 100%;
    height: 44px;
    line-height: 44px;
    background-color: #ffffff;
    box-shadow: inset 0px -1px 0px 0px #f7f7fa;
    justify-content: space-between;
    span {
      padding-left: 24px;
      font-size: 14px;
      letter-spacing: 0px;
      color: #171f46;
    }
    i {
      width: 16px;
      height: 16px;
      background-image: url("../../assets/img/close.svg");
      margin: 15px 24px;
      cursor: pointer;
    }
  }
  .content{
    width: 100%;
    height: 121px;
    padding: 24px;
    input{
      width:312px;
      height:32px;
      background:rgba(247,248,252,1);
      border-radius:2px;
      border: none;
      padding: 7px 11px;
      color: #464D6C;
      outline: none;
    }
  }
  .footer {
    width: 100%;
    height: 64px;
    background-color: #ffffff;
    box-shadow: inset 0px 1px 0px 0px #f7f7fa;
    padding: 16px 0;
    position: relative;
    .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 136px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          border-radius: 2px;
          border: none;
          &:hover {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:active {
            color: #464d6c;
            background-color: #eaeaed;
          }
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          margin-left: 16px;
          border-radius: 2px;
          border: none;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
      }
  }
}
</style>
